import { Badge } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useCompanyFeatures } from 'app/domains/companies';
import { useDocumentProjectsCount } from './useDocumentProjectsCount';
import { ListButton } from '../ListButton';
export function ProjectsButton() {
    const { isFeatureAvailable } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('projects');
    const { count } = useDocumentProjectsCount(!isProjectsAvailable);
    if (!isProjectsAvailable) {
        return null;
    }
    return (<ListButton settingsKey="projects" icon={<Falcon icon="rectangle-history"/>} endElement={count > 0 && <Badge size="small" appearance="secondary" value={count}/>}/>);
}
